import type { ProductTab } from '@/features/products/types/product-tab.type';

export const APP_ROUTE = {
  APP: {
    ROOT: {
      path: '/',
      getHref: () => '/',
    },
  },

  AUTH: {
    ROOT: {
      path: 'auth',
      getHref: () => '/auth',
    },

    SIGN_IN: {
      path: 'sign-in',
      getHref: (redirectTo?: string | null) =>
        `/auth/sign-in${redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : ''}`,
    },
  },

  ANALYTICS: {
    DASHBOARD: {
      path: 'dashboard',
      getHref: () => '/dashboard',
    },
  },

  PRODUCTS: {
    ROOT: {
      path: 'products',
      getHref: (tab?: ProductTab) => `/products${tab ? `?tab=${tab}` : ''}`,
    },

    CREATE_DIGITAL: {
      path: 'create-digital',
      getHref: () => '/products/create-digital',
    },

    CREATE_EVENT: {
      path: 'create-event',
      getHref: () => '/products/create-event',
    },

    UPDATE_DIGITAL: {
      path: ':id/update-digital-product',
      getHref: (id: string) => `/products/${id}/update-digital-product`,
    },

    UPDATE_EVENT: {
      path: ':id/update-event-product',
      getHref: (id: string) => `/products/${id}/update-event-product`,
    },

    CREATE_TRYOUT: {
      path: 'create-tryout',
      getHref: () => '/products/create-tryout',
    },

    UPDATE_TRYOUT: {
      path: ':id/update-tryout-product',
      getHref: (id: string) => `/products/${id}/update-tryout-product`,
    },

    CREATE_BUNDLE: {
      path: 'create-bundle',
      getHref: () => '/products/create-bundle',
    },

    UPDATE_BUNDLE: {
      path: ':id/update-bundle-product',
      getHref: (id: string) => `/products/${id}/update-bundle-product`,
    },
  },

  ERROR: {
    NOT_FOUND: {
      path: '404',
      getHref: () => '/404',
    },
    FORBIDDEN: {
      path: '403',
      getHref: () => '/403',
    },
    MAINTENANCE: {
      path: 'maintenance',
      getHref: () => '/maintenance',
    },
  },

  ROLES: {
    ROOT: {
      path: 'roles',
      getHref: () => '/roles',
    },
  },

  ADMINS: {
    ROOT: {
      path: 'admin',
      getHref: () => '/admin',
    },
  },

  USERS: {
    ROOT: {
      path: 'users',
      getHref: () => '/users',
    },
  },

  SESSIONS: {
    ROOT: {
      path: 'sessions',
      getHref: () => '/sessions',
    },
    MENTOR: {
      path: 'mentor',
      getHref: () => '/sessions/mentor',
    },
    NO_SHOW_CLAIMS: {
      path: 'no-show-claims',
      getHref: () => '/sessions/no-show-claims',
    },
  },

  WITHDRAWS: {
    ROOT: {
      path: 'withdraws',
      getHref: () => '/withdraws',
    },
  },

  UNIVERSITIES: {
    ROOT: {
      path: 'universities',
      getHref: () => '/universities',
    },
  },

  QUESTION_BANKS: {
    ROOT: {
      path: 'question-banks',
      getHref: () => '/question-banks',
    },

    CREATE: {
      path: 'create',
      getHref: () => '/question-banks/create',
    },

    UPDATE: {
      path: ':id/update',
      getHref: (id: string) => `/question-banks/${id}/update`,
    },
  },

  ASSESSMENT_FORMATS: {
    ROOT: {
      path: 'assessment-formats',
      getHref: () => '/assessment-formats',
    },
  },

  CERTIFICATES: {
    ROOT: {
      path: 'certificates',
      getHref: () => '/certificates',
    },
  },

  VOUCHERS: {
    ROOT: {
      path: 'vouchers',
      getHref: () => '/vouchers',
    },
  },

  PRODUCT_CLAIM: {
    ROOT: {
      path: 'product-claim',
      getHref: () => '/product-claim',
    },
  },

  ORDERS: {
    ROOT: {
      path: 'orders',
      getHref: () => '/orders',
    },
  },

  TRANSACTIONS: {
    ROOT: {
      path: 'transactions',
      getHref: () => '/transactions',
    },
  },

  SETTINGS: {
    ROOT: {
      path: 'settings',
      getHref: () => '/settings',
    },
    TESTING_COMPONENT: {
      path: 'testing-component',
      getHref: () => '/settings/testing-component',
    },
    QR_GENERATOR: {
      path: 'qr-generator',
      getHref: () => '/settings/qr-generator',
    },
  },

  HIGHLIGHT_CONTENT: {
    ROOT: {
      path: 'highlight-content',
      getHref: () => '/highlight-content',
    },
  },

  NOTIFICATIONS: {
    ROOT: {
      path: 'notifications',
      getHref: () => '/notifications',
    },
  },

  ROUTE_NOT_FOUND: {
    path: '*',
    getHref: () => '*',
  },
} as const;
